export default __webpack_public_path__ + "static/media/Cookie-Regular.561be922.ttf";